import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow } from "vue";
const _hoisted_1 = {
  class: "setting-container"
};
const _hoisted_2 = {
  class: "setting-wrapper"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "desc"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_bread_crumb = _resolveComponent("bread-crumb");
  const _component_router_view = _resolveComponent("router-view");
  const _directive_has = _resolveDirective("has");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_bread_crumb), _withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.settingMenus, item => {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "item",
      onClick: $event => _ctx.$router.push('/helping-center/' + item.path),
      key: item.path
    }, [_createElementVNode("img", {
      src: item.meta.icon,
      alt: "",
      class: "icon"
    }, null, 8, _hoisted_4), _createElementVNode("h2", {
      innerHTML: item.meta.title
    }, null, 8, _hoisted_5), _createElementVNode("p", _hoisted_6, _toDisplayString(item.meta.desc), 1)], 8, _hoisted_3)), [[_directive_has, item.meta.permission]]);
  }), 128))])], 512), [[_vShow, _ctx.$route.path === '/helping-center']]), _createVNode(_component_router_view)], 64);
}